<template>
  <v-container class="px-5 d-flex align-center justify-center" style="height: 95vh" fluid>
    <div>
      <div class="d-flex align-center justify-center">
        <h1 class="text-center">{{ $t('seeOurNewFeatures') }}</h1>
        <v-icon class="ml-2" color="#111111">fa-grin-stars</v-icon>
      </div>
      <h3 class="text-center">{{ $t('swisetFeaturesRoadmap') }}</h3>
      <v-row class="my-7" align="center" justify="center">
        <FeaturesList :features="features" :already-voted="featuresVotes" @vote="vote"/>
      </v-row>
      <v-row class="my-3" align="center" justify="center">
        <div @click="overlayPropose = true" style="cursor: pointer" class="d-flex align-center justify-center">
          <v-icon color="#156200" class="mr-3" small>fa-meteor</v-icon>
          <p style="color: #156200" class="text-center mt-4">{{ $t('proposeFeature') }}</p>
        </div>
      </v-row>
    </div>

    <!-- Overlay to vote for a feature!-->
    <v-overlay :dark="false" v-model="overlayVote">
      <FeatureVote :feature="featureToVote" @successfulVote="successfulVote" @closeWindow="overlayVote = false"/>
    </v-overlay>

    <!-- Overlay to propose a feature!-->
    <v-overlay :dark="false" v-model="overlayPropose">
      <ProposeFeature @closeWindow="overlayPropose = false"/>
    </v-overlay>
  </v-container>
</template>

<script>
import Repository from '../../repositories/analytics';
import FeaturesList from "@/views/Feedback/components/FeaturesList";
import FeatureVote from "@/views/Feedback/components/FeatureVote";
import ProposeFeature from "@/views/Feedback/components/ProposeFeature";
export default {
  name: "FeedbackIndex",
  components: {ProposeFeature, FeatureVote, FeaturesList},
  data() {
    return {
      features: [],
      featuresVotes: [],

      featureToVote: null,
      overlayVote: false,
      overlayPropose: false,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      Repository.allFeatures().then((response) => {
        if(response.status < 400)
          this.features = response.data;
      });
      Repository.votesByUser(this.$store.state.user.id).then((response) => {
        if(response.status < 400)
          this.featuresVotes = response.data;
      });
    },
    successfulVote(feature) {
      this.featuresVotes.push(feature);
    },
    vote(feature) {
      this.featureToVote = feature;
      this.overlayVote = true;
    },
  }
}
</script>

<style scoped>

</style>



